import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import {
  IFloorplanNavigatorInstancePointOfInterestMedia,
} from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/floorplan_navigator_instance_point_of_interest_media';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  relations: [],
  select: [
    'fpnipoim.fpnInstancePointOfInterestId',
    'fpnipoim.path',
    'fpnipoim.order',
    'fpnipoim.createdUserId',
  ],
  limit: 'false',
  alias: 'fpnipoim',
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  alias: 'fpnipoim',
  relations: [],
  select: [
    'fpnipoim.fpnInstancePointOfInterestId',
    'fpnipoim.path',
    'fpnipoim.order',
    'fpnipoim.createdUserId',
  ],
};
const base = new StoreBaseImplementationV2<IFloorplanNavigatorInstancePointOfInterestMedia>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
